import { Fragment } from "react";
import moment from "moment";

export const LabColumnsNoSelected = [
  {
    key: "region_name",
    name: "Region",
  },
  {
    key: "in_depth",
    name: "Depth",
    renderCell: ({ row }) => {
      return (
        <Fragment>
          {row.in_depth}
        </Fragment>
      );
    },
  },
  {
    key: "method",
    name: "Method",
    renderCell: ({ row }) => (row.method === 0 ? "BLE" : "LN"),
  },
  {
    key: "tree_type",
    name: "TreeType"
    // renderCell: ({ row }) => (row.tree_type === 0 ? "COF" : "DUR"),
  },
  {
    key: "last_active",
    name: "LastActive",
    renderGroupCell({ childRows }) {
      const validDates = childRows
        .map(({ last_active }) => {
          var dateMomentObject = moment(
            last_active,
            "DD/MM/YYYY hh:m:ss"
          ).toDate();
          return last_active ? dateMomentObject : null;
        })
        .filter((date) => date !== null);

      // If all last_active values are null, return null
      if (validDates.length === 0) {
        return null;
      }
      // Find the maximum date
      const maxDateTime = validDates.reduce((max, currentDateTime) => {
        return currentDateTime > max ? currentDateTime : max;
      }, new Date(0)); // Initialize with the earliest possible date

      const daysDiff = moment().diff(maxDateTime, 'days');
      const formattedDate = moment(maxDateTime).format("lll");
      return (
        <span style={{ color: daysDiff >= 1 ? 'red' : 'inherit' }}>
          {formattedDate}
        </span>
      );
    },
  },
  {
    key: "QrSensor",
    name: "QrSensor",
    renderGroupCell({ childRows }) {
      return childRows.reduce((prev, { recent }) => {
        return recent !== null ? prev + 1 : prev;
      }, 0);
    },
  },
  {
    key: "QrBox",
    name: "QrBox",
    renderGroupCell({ childRows }) {
      return childRows.reduce((prev, { recent }) => {
        return recent !== null ? prev + 1 : prev;
      }, 0);
    },
  },
  {
    key: "QrGateway",
    name: "QrGateway",
    renderGroupCell({ childRows }) {
      return childRows.reduce((prev, { recent }) => {
        return recent !== null ? prev + 1 : prev;
      }, 0);
    },
  }
];

export const OtherColumnsNoSelected = [
  {
    key: "farm_name",
    name: "Farm",
    width: 100,
  },
  {
    key: "owner_phone",
    name: "Phone",
    width: 100,
    renderCell: ({ row }) => (row.owner_phone ? row.owner_phone.replace('+84 ', '0') : '')
  },
  {
    key: "region_name",
    name: "Region",
  },
  {
    key: "in_depth",
    name: "Depth",
    renderCell: ({ row }) => {
      return (
        <Fragment>
          {row.in_depth}
        </Fragment>
      );
    },
  },
  {
    key: "method",
    name: "Method",
    renderCell: ({ row }) => (row.method === 0 ? "BLE" : "LN"),
  },
  {
    key: "tree_type",
    name: "TreeType"
    // renderCell: ({ row }) => {
    //   return row.tree_type === 0 ? "COF" : "DUR";
    // },
  },
  {
    key: "last_active",
    name: "LastActive",
    renderCell({ row }) {
      if (!row.last_active) return null;
  
      const dateMomentObject = moment(row.last_active, "DD/MM/YYYY hh:m:ss");
      const now = moment();
      const diffInDays = now.diff(dateMomentObject, 'days');
      
      const formattedDate = dateMomentObject.format("lll");
      return (
        <span style={{ color: diffInDays >= 1 ? 'red' : 'inherit' }}>
          {formattedDate}
        </span>
      );
    },
    renderGroupCell({ childRows }) {
      const validDates = childRows
        .map(({ last_active }) => {
          var dateMomentObject = moment(
            last_active,
            "DD/MM/YYYY hh:m:ss"
          ).toDate();
          return last_active ? dateMomentObject : null;
        })
        .filter((date) => date !== null);
  
      if (validDates.length === 0) {
        return null;
      }
  
      const minDateTime = validDates.reduce((min, currentDateTime) => {
        return currentDateTime < min ? currentDateTime : min;
      }, new Date());
  
      const daysDiff = moment().diff(minDateTime, 'days');
      const formattedDate = moment(minDateTime).format("lll");
      
      return (
        <span style={{ color: daysDiff >= 1 ? 'red' : 'inherit' }}>
          {formattedDate}
        </span>
      );
    }
  },
  {
    key: "QrSensor",
    name: "QrSensor",
    renderGroupCell({ childRows }) {
      return childRows.reduce((prev, { recent }) => {
        return recent !== null ? prev + 1 : prev;
      }, 0);
    },
  },
  {
    key: "QrBox",
    name: "QrBox",
    renderGroupCell({ childRows }) {
      return childRows.reduce((prev, { recent }) => {
        return recent !== null ? prev + 1 : prev;
      }, 0);
    },
  },
  {
    key: "QrGateway",
    name: "QrGateway",
    renderGroupCell({ childRows }) {
      return childRows.reduce((prev, { recent }) => {
        return recent !== null ? prev + 1 : prev;
      }, 0);
    },
  },
  {
    key: "lat",
    name: "Lat",
    renderCell: ({ row }) => {
      return (
        <Fragment>
          {row.lat}
        </Fragment>
      );
    },
  },
  {
    key: "long",
    name: "Long",
    renderCell: ({ row }) => {
      return (
        <Fragment>
          {row.long}
        </Fragment>
      );
    },
  }
];

export const RawDataColumns = [
  {
    key: "id",
    name: "ID",
    width: 20,
  },
  {
    key: "created_at",
    name: "created_at",
    width: 200,
  },
  {
    key: "N",
    name: "N",
  },
  {
    key: "P",
    name: "P",
    type: "number",
  },
  {
    key: "K",
    name: "K",
  },
  {
    key: "Moist",
    name: "Moist",
  },
  {
    key: "Temperature",
    name: "Temperature",
  },
  {
    key: "EC",
    name: "EC",
  },
  {
    key: "pH",
    name: "pH",
    type: "number",
  },
];
